<template>
  <v-container>
    <!-- Split Header Layout -->
    <v-row class="mb-6 align-center px-4">
      <div class="d-flex align-center py-4">
        <div>
          <div class="text-h4 font-weight-black primary--text d-flex align-center">
            Etapas de Pre-Prensa
          </div>
          <div class="caption grey--text font-weight-medium">Configuración de l flujo de pre-producción</div>
        </div>
      </div>
      <v-spacer></v-spacer>
      <div class="d-flex align-center">
        <v-btn color="primary" depressed class="px-6 shadow-sm" @click="update(-1)">
          <v-icon small class="mr-2">fas fa-plus</v-icon>
          Nueva Etapa
        </v-btn>
      </div>
    </v-row>

    <!-- Search Area -->
    <v-row justify="end" class="px-4 mb-4">
      <v-col cols="12" md="5">
        <v-text-field
          v-model="search"
          label="Buscar etapa..."
          prepend-inner-icon="fas fa-search"
          outlined
          dense
          hide-details="auto"
          clearable
          class="modern-search-field"
          :disabled="loading"
        />
      </v-col>
    </v-row>

    <!-- Data Table -->
    <v-card outlined class="modern-card elevation-0 overflow-hidden mx-4">
      <v-data-table
        :headers="headers"
        :items="items"
        :loading="loading"
        :search="search"
        sort-by="sort"
        class="modern-table"
        :footer-props="{
          showFirstLastPage: true,
          itemsPerPageOptions: [10, 20, 50],
        }"
      >
        <template v-slot:item.name="{ item }">
          <v-chip
            :color="item.color || 'primary'"
            label
            outlined
            small
            class="font-weight-black text-uppercase shadow-xs"
            style="min-width: 140px; justify-content: center;"
          >
            {{ item.name }}
          </v-chip>
        </template>

        <template v-slot:item.sort="{ item }">
          <v-avatar size="28" color="primary lighten-4" class="font-weight-black primary--text body-2 shadow-sm">
            {{ item.sort }}
          </v-avatar>
        </template>

        <template v-slot:item.enabled="{ item }">
          <v-chip
            small
            label
            :color="item.enabled ? 'success' : 'grey'"
            text-color="white"
            class="font-weight-bold"
          >
            <v-icon x-small left>{{ item.enabled ? 'fas fa-check' : 'fas fa-ban' }}</v-icon>
            {{ item.enabled ? 'Activa' : 'Desactivada' }}
          </v-chip>
        </template>

        <template v-slot:item.actions="{ item }">
          <div class="d-flex justify-center">
            <v-btn
              icon small
              :color="item.enabled ? 'grey darken-1' : 'success'"
              class="grey lighten-4 shadow-sm mr-1"
              :loading="togglingId === item.id"
              @click.stop="toggleEnabled(item)"
            >
              <v-icon x-small>{{ item.enabled ? 'fas fa-toggle-off' : 'fas fa-toggle-on' }}</v-icon>
            </v-btn>
            <v-btn icon small color="primary" class="grey lighten-4 shadow-sm" @click.stop="update(item.id)">
              <v-icon x-small>fas fa-edit</v-icon>
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <!-- Dialog -->
    <v-dialog v-model="showDialog" max-width="500" persistent>
      <v-card outlined class="modern-card overflow-hidden">
        <stage-create-update  
          :id="item"
          @updated="fetch"
          @close="showDialog=false"
        />
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {fetchStages, updateStage} from '@/api/production'
import notifications from '@/utils/notifications'
import StageCreateUpdate from '@/components/production/StageCreateUpdate'

export default {
  name: 'Stages',
  components: { StageCreateUpdate },
  data() {
    return {
      loading: false,
      togglingId: null,
      item: '',
      items: [],
      search: '',
      showDialog: false,
      headers: [
        { text: 'Orden', align: 'center', value: 'sort', class: 'grey lighten-4', width: '100' },
        { text: 'Nombre de Etapa', align: 'start', value: 'name', class: 'grey lighten-4' },
        { text: 'Estado', value: 'enabled', align: 'center', class: 'grey lighten-4', width: '140' },
        { text: 'Acciones', value: 'actions', align: 'center', class: 'grey lighten-4', sortable: false, width: '120' }
      ]
    }
  },
  methods: {
    async fetch() {
      this.loading = true
      try {
        const res = await fetchStages()
        this.items = res
      } catch (err) {
        notifications.showError('Error cargando etapas: ' + err)
      } finally {
        this.loading = false
      }
    },
    update(id) {
      this.item = id
      this.showDialog = true
    },
    async toggleEnabled(item) {
      this.togglingId = item.id
      try {
        await updateStage(item.id, { enabled: !item.enabled })
        notifications.showSuccess(item.enabled ? 'Etapa desactivada' : 'Etapa activada')
        await this.fetch()
        this.$store.dispatch('getStages')
      } catch (err) {
        notifications.showError('Error al cambiar estado: ' + err)
      } finally {
        this.togglingId = null
      }
    }
  },
  async mounted() {
    this.fetch()
  }
}
</script>

<style scoped>
.modern-card {
  border: 1px solid rgba(0,0,0,0.08) !important;
  border-radius: 12px !important;
}
.shadow-sm { box-shadow: 0 2px 4px rgba(0,0,0,0.05) !important; }
.shadow-xs { box-shadow: 0 1px 2px rgba(0,0,0,0.03) !important; }
</style>